export default __webpack_public_path__ + "static/media/vg-logo.b61e6408.png";